import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";

interface SeoSection {
  heading: string;
  body?: string[];
  bullets?: string[];
}

interface SeoPageData {
  title: string;
  lead: string;
  sections: SeoSection[];
}

@Component({
  selector: "app-seo-page",
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: "./seo-page.component.html",
  styleUrl: "./seo-page.component.css"
})
export class SeoPageComponent implements OnInit {
  page: SeoPageData | null = null;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.page = (data["seoPage"] as SeoPageData | undefined) ?? null;
    });
  }
}
